import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import { Button } from "@/components/ui/button";
import {
  GeneralIllustrationLg,
  YesNoLg,
  CheckListIllustrationLg
} from "@dreamhub/designsystem/icons";
import { ContractsWorkflowType } from "./types";

interface WorkflowTypesContentProps {
  onStartBuilding: (workflowType: ContractsWorkflowType) => void;
}

const WorkflowTypesContent: React.FC<WorkflowTypesContentProps> = ({
  onStartBuilding
}) => {
  const { t } = useTranslation();

  return (
    <div className="p-6">
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-surface-elevation2 hover:bg-surface-hover-soft rounded-2xl p-4 flex flex-col gap-5 border border-border-border1 shadow-sm">
          <div className="h-32 flex items-center justify-center bg-surface-tertiary rounded-lg">
            <GeneralIllustrationLg />
          </div>
          <div className="flex flex-col gap-2">
            <Text variant="smSubtitle" className="text-primary">
              {t("workflows.types.general")}
            </Text>
            <Text variant="bodySecondary" className="text-secondary">
              {t("workflows.descriptions.general")}
            </Text>
          </div>
          <div className="flex justify-end">
            <Button
              variant="primary"
              onClick={() => onStartBuilding(ContractsWorkflowType.GENERAL)}
              className="mt-auto w-fit"
            >
              {t("workflows.actions.startBuilding")}
            </Button>
          </div>
        </div>
        <div className="bg-surface-elevation2 hover:bg-surface-hover-soft rounded-2xl p-4 flex flex-col gap-5 border border-border-border1 shadow-sm">
          <div className="h-32 flex items-center justify-center bg-surface-tertiary rounded-lg">
            <YesNoLg />
          </div>
          <div className="flex flex-col gap-2">
            <Text variant="smSubtitle" className="text-primary">
              {t("workflows.types.yesNoQuestionnaire")}
            </Text>
            <Text variant="bodySecondary" className="text-secondary">
              {t("workflows.descriptions.yesNoQuestionnaire")}
            </Text>
          </div>
          <div className="flex justify-end">
            <Button
              variant="primary"
              onClick={() =>
                onStartBuilding(ContractsWorkflowType.YES_NO_QUESTIONNAIRE)
              }
              className="mt-auto w-fit"
            >
              {t("workflows.actions.startBuilding")}
            </Button>
          </div>
        </div>
        <div className="bg-surface-elevation2 hover:bg-surface-hover-soft rounded-2xl p-4 flex flex-col gap-5 border border-border-border1 shadow-sm">
          <div className="h-32 flex items-center justify-center bg-surface-tertiary rounded-lg">
            <CheckListIllustrationLg />
          </div>
          <div className="flex flex-col gap-2">
            <Text variant="smSubtitle" className="text-primary">
              {t("workflows.types.checklist")}
            </Text>
            <Text variant="bodySecondary" className="text-secondary">
              {t("workflows.descriptions.checklist")}
            </Text>
          </div>
          <div className="flex justify-end">
            <Button
              variant="primary"
              onClick={() => onStartBuilding(ContractsWorkflowType.CHECKLIST)}
              className="mt-auto w-fit"
            >
              {t("workflows.actions.startBuilding")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkflowTypesContent;
